export default {
    set(state, payload) {
        payload.preference.responses = payload.responses
    },
    setHeartRateInputMethod(state, value) {
        state.heartRateInputMethod = value
    },
    setRespiratoryRateInputMethod(state, value) {
        state.respiratoryRateInputMethod = value
    }
}
